import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { UserTestResponseUtils } from '@marvelapp/user-test-creator';
import CreateTestResult from './CreateTestResult';
import { getResumableResponseUUID } from './Resume';
export const GetOrCreateLiveSession = observer(function GetOrCreateLiveSession() {
    const { shareUUID } = useParams();
    const resumableResponseUUID = getResumableResponseUUID(shareUUID, true);
    const [roomName, setRoomName] = useState();
    const [_, setPartnerData] = useState(null);
    if (roomName) {
        return (_jsx(Redirect, { to: `/share/live/participant/${shareUUID}/${roomName}` }));
    }
    return (_jsx(CreateTestResult, { onTestCreate: (_, roomName) => setRoomName(roomName), setPartnerData: setPartnerData, shareUUID: shareUUID, isLive: true, resumableLiveSessionResponseUUID: resumableResponseUUID !== null && resumableResponseUUID !== void 0 ? resumableResponseUUID : UserTestResponseUtils.generateResponseUUID() }));
});
